/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ConversationTypeTemplateKind = {
    NotifyParticipantsViaSms: 'NOTIFY_PARTICIPANTS_VIA_SMS',
    NotifyParticipantsViaEmail: 'NOTIFY_PARTICIPANTS_VIA_EMAIL',
    RequestLocation: 'REQUEST_LOCATION'
} as const;
export type ConversationTypeTemplateKind = typeof ConversationTypeTemplateKind[keyof typeof ConversationTypeTemplateKind];


export function instanceOfConversationTypeTemplateKind(value: any): boolean {
    for (const key in ConversationTypeTemplateKind) {
        if (Object.prototype.hasOwnProperty.call(ConversationTypeTemplateKind, key)) {
            if (ConversationTypeTemplateKind[key as keyof typeof ConversationTypeTemplateKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConversationTypeTemplateKindFromJSON(json: any): ConversationTypeTemplateKind {
    return ConversationTypeTemplateKindFromJSONTyped(json, false);
}

export function ConversationTypeTemplateKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationTypeTemplateKind {
    return json as ConversationTypeTemplateKind;
}

export function ConversationTypeTemplateKindToJSON(value?: ConversationTypeTemplateKind | null): any {
    return value as any;
}

export function ConversationTypeTemplateKindToJSONTyped(value: any, ignoreDiscriminator: boolean): ConversationTypeTemplateKind {
    return value as ConversationTypeTemplateKind;
}

